var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.485 2.083H4.472L5.79 3.93v12.137l-1.583 1.847h11.345l1.847-2.639H9.485V2.083z",
    fill: "url(#lol_svg__paint0_linear_3684_16024)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.736 5.356a7.364 7.364 0 00-2.111 5.17c0 2.008.801 3.83 2.102 5.161l.009-.01v-1.65a6.303 6.303 0 01-1.056-3.5c0-1.295.389-2.5 1.056-3.502V5.356z",
    fill: "url(#lol_svg__paint1_linear_3684_16024)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.156 14.22A6.333 6.333 0 0010.54 4.216V3.157a7.388 7.388 0 015.872 11.063h-1.256z",
    fill: "url(#lol_svg__paint2_linear_3684_16024)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.78 14.22a5.277 5.277 0 00-3.24-8.944v8.944h3.24z",
    fill: "url(#lol_svg__paint3_radial_3684_16024)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lol_svg__paint0_linear_3684_16024",
    x1: 0.852,
    y1: 17.914,
    x2: 15.419,
    y2: 0.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF893D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#D29D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FFCC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#E8B55D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lol_svg__paint1_linear_3684_16024",
    x1: 0.852,
    y1: 17.914,
    x2: 15.419,
    y2: 0.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF893D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#D29D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FFCC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#E8B55D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lol_svg__paint2_linear_3684_16024",
    x1: 0.852,
    y1: 17.914,
    x2: 15.419,
    y2: 0.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF893D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#D29D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FFCC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#E8B55D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lol_svg__paint3_radial_3684_16024",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-47.911 19.69 -1.189) scale(11.0214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#117D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#2FEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#117D8D"
  })))));
}
export default __webpack_public_path__ + "static/svg/lol.svg";
export { SvgLol as ReactComponent };